import React from 'react';
import {Fab} from "@material-ui/core";
import {ExpandMore} from "@material-ui/icons";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '& > *': {
                margin: theme.spacing(1),
            },
        },
        extendedIcon: {
            marginRight: theme.spacing(1),
        },
        buttonBox: {
            flex: '2 0',
            textAlign: 'center',
            minWidth: '80%',
            margin: '2rem 50vw',
        },
        button: {
            margin: 'auto',
            minWidth: '20rem',
            backgroundColor: 'rgba(255,255,255,0.55)',

        }

    }),
);

const FrontMoreButton = (props: any) => {
    // <button className={classes.FrontMoreButton}>Find out more ...</button>
    const classes = useStyles();
    return (
        <div className={classes.buttonBox}>
            <Fab variant="extended" className={classes.button} onClick={props.clicked}>
                <ExpandMore className={classes.extendedIcon}/>
                Find out more
            </Fab>
        </div>
    )

}


export default FrontMoreButton;
